{
  "app.wordmark": "antoja",
  "app.section": "Consola",
  "home.title": "Resumen",
  "home.subtitle": "Las zonas del piloto. Aquí vas a ver la cobertura, la cola y el uso de los límites gratis.",
  "connection.missing.title": "Falta configurar Supabase",
  "connection.missing.body": "Define {vars} en apps/console/.env.local (copia .env.example) y vuelve a iniciar el servidor.",
  "connection.invalid.body": "Revisa {vars}: el valor no tiene el formato esperado.",
  "zones.heading": "Zonas piloto",
  "zones.loading": "Cargando zonas…",
  "zones.empty": "Todavía no hay zonas piloto. Corre supabase db reset para cargar la semilla.",
  "zones.error": "No se pudieron cargar las zonas. Revisa que Supabase esté encendido y que la URL sea correcta.",
  "common.retry": "Reintentar",
  "nav.label": "Consola",
  "nav.home": "Resumen",
  "nav.places": "Lugares",
  "role.admin": "Administrador",
  "role.editor": "Editor",
  "role.verifier": "Verificador",
  "auth.loading": "Revisando tu sesión…",
  "auth.error": "No se pudo revisar tu acceso. Revisa tu conexión e intenta de nuevo.",
  "auth.denied.title": "Esta cuenta no es del equipo",
  "auth.denied.body": "{email} no tiene acceso a la consola. Si debería tenerlo, pide que te agreguen al equipo.",
  "auth.signOut": "Salir",
  "login.title": "Entra a la consola",
  "login.subtitle.password": "Solo para las cuentas del equipo.",
  "login.subtitle.link": "Te enviamos un enlace al correo para entrar sin contraseña.",
  "login.subtitle.reset": "Te enviamos un enlace al correo para crear una contraseña nueva.",
  "login.email": "Correo",
  "login.password": "Contraseña",
  "login.submit.password": "Entrar",
  "login.submit.link": "Enviar enlace",
  "login.submit.reset": "Enviar enlace",
  "login.signingIn": "Entrando…",
  "login.sending": "Enviando…",
  "login.toReset": "¿No tienes contraseña o la olvidaste?",
  "login.toLink": "Entrar con un enlace al correo",
  "login.backToPassword": "Entrar con contraseña",
  "login.reset.title": "Crea tu contraseña",
  "login.error.invalid_email": "Escribe un correo válido, por ejemplo nombre@dominio.com.",
  "login.error.missing_password": "Escribe tu contraseña.",
  "login.error.invalid_credentials": "El correo o la contraseña no coinciden.",
  "login.error.rate_limited": "Hubo demasiados intentos. Espera unos minutos y vuelve a intentar.",
  "login.error.failed": "No se pudo completar. Revisa tu conexión e intenta de nuevo.",
  "login.sent.title": "Revisa tu correo",
  "login.sent.body": "Si {email} es del equipo, te llegará un enlace para entrar. Ábrelo en este mismo navegador.",
  "login.reset.sent": "Si {email} es del equipo, te llegará un enlace para crear tu contraseña. Ábrelo en este mismo navegador.",
  "login.sent.limit": "Si no llega en unos minutos, revisa spam. Solo se pueden enviar unos pocos correos por hora.",
  "account.title": "Tu cuenta",
  "account.subtitle": "{email} · {role}",
  "account.password.title": "Contraseña",
  "account.password.help": "Con una contraseña entras sin esperar el correo. Mientras escribes, te mostramos lo que le falta.",
  "account.password.recovery": "Entraste con el enlace del correo. Crea tu contraseña nueva aquí.",
  "account.password.new": "Contraseña nueva",
  "account.password.confirm": "Repite la contraseña",
  "account.password.save": "Guardar contraseña",
  "account.password.saving": "Guardando…",
  "account.password.saved": "Contraseña guardada. La próxima vez entra con ella.",
  "account.password.error.too_short": "Usa al menos 12 caracteres.",
  "account.password.error.too_long": "Es demasiado larga. Usa una más corta (las tildes y la ñ cuentan doble).",
  "account.password.error.common": "Esa contraseña es muy fácil de adivinar. Usa una frase propia, sin antoja, tu nombre ni secuencias como 123456.",
  "account.password.error.mismatch": "Las dos contraseñas no coinciden.",
  "account.password.error.weak_password": "Esa contraseña es muy fácil de adivinar. Prueba con otra más larga.",
  "account.password.error.same_password": "Es igual a la que ya tienes. Escribe una distinta.",
  "account.password.error.reauthentication_needed": "Por seguridad, sal y vuelve a entrar, y cambia la contraseña enseguida.",
  "account.password.error.rate_limited": "Hubo demasiados intentos. Espera unos minutos y vuelve a intentar.",
  "account.password.error.failed": "No se pudo guardar. Revisa tu conexión e intenta de nuevo.",
  "account.link": "Tu cuenta",
  "account.short": "Cuenta",
  "notFound.title": "No encontramos esta página",
  "notFound.body": "La dirección no existe o cambió.",
  "notFound.back": "Volver al resumen",
  "places.title": "Lugares",
  "places.subtitle": "{total} lugares en el catálogo",
  "places.search": "Buscar por nombre",
  "places.searchPlaceholder": "Mondongos, Sushi, La Fonda…",
  "places.zone": "Barrio",
  "places.allZones": "Todos los barrios",
  "places.noZone": "Sin barrio",
  "places.filterLabel": "Mostrar",
  "places.filter.all": "Todos",
  "places.filter.ready": "Listos para publicar",
  "places.filter.unverified": "Falta verificar",
  "places.filter.published": "Publicados",
  "places.filter.unpublished": "Sin publicar",
  "places.filter.hidden": "Ocultos",
  "places.loading": "Cargando lugares…",
  "places.error": "No se pudieron cargar los lugares. Revisa tu conexión e intenta de nuevo.",
  "places.empty": "No hay lugares con estos filtros.",
  "places.column.name": "Lugar",
  "places.column.zone": "Barrio",
  "places.column.status": "Negocio",
  "places.column.verification": "Verificación",
  "places.column.app": "En la app",
  "places.showing": "Mostrando {from}–{to} de {total}",
  "places.previous": "Anterior",
  "places.next": "Siguiente",
  "placeStatus.unconfirmed": "Por confirmar",
  "placeStatus.active": "Abierto",
  "placeStatus.temporarily_closed": "Cerrado por un tiempo",
  "placeStatus.closed": "Cerrado",
  "verification.verified": "Verificado",
  "verification.conflicting": "En conflicto",
  "verification.expired": "Vencido",
  "verification.single_source": "Una fuente",
  "verification.none": "Sin datos",
  "inApp.published": "Publicado",
  "inApp.unpublished": "Sin publicar",
  "inApp.hiddenUntil": "Oculto hasta el {date}",
  "fact.location": "Ubicación",
  "fact.business_status": "Estado del negocio",
  "factStatus.verified": "Verificado",
  "factStatus.single_source": "Una fuente",
  "factStatus.conflicting": "En conflicto",
  "factStatus.expired": "Vencido",
  "place.loading": "Cargando el lugar…",
  "place.error": "No se pudo cargar el lugar. Revisa tu conexión e intenta de nuevo.",
  "place.notFound": "Este lugar no existe o no tienes acceso",
  "place.data": "Datos del lugar",
  "place.readOnly": "Tu rol puede ver los lugares, pero no editarlos.",
  "place.name": "Nombre",
  "place.address": "Dirección",
  "place.status": "Estado del negocio",
  "place.priceLevel": "Nivel de precio",
  "place.priceUnknown": "Sin definir",
  "place.googleId": "ID de Google (solo el ID)",
  "place.googleIdHint": "Cambiar o borrar el ID de Google quita la verificación del lugar y lo despublica.",
  "place.fsqId": "ID de Foursquare",
  "place.fsqIdHint": "Lo pone la importación de Foursquare; aquí solo se consulta.",
  "place.nameHint": "Cambiar la ubicación o el nombre quita la verificación de ubicación y despublica el lugar.",
  "place.invalid": "Revisa los datos: el nombre debe tener entre 2 y 120 caracteres.",
  "place.save": "Guardar cambios",
  "place.saving": "Guardando…",
  "place.saved": "Cambios guardados.",
  "place.saveError": "No se pudo guardar. Revisa tu conexión e intenta de nuevo.",
  "place.verification": "Verificación",
  "place.factMissing": "Sin datos todavía",
  "place.inApp": "En la app",
  "place.publishNeedsVerification": "Para publicarlo, la ubicación y el estado del negocio deben estar verificados por dos familias de fuentes.",
  "place.publish": "Publicar en la app",
  "place.unpublish": "Quitar de la app",
  "dbError.auth_required": "Tu sesión terminó. Vuelve a entrar.",
  "dbError.evidence_empty": "La evidencia necesita un valor o una comparación.",
  "dbError.fsq_id_locked": "El ID de Foursquare lo pone la importación de Foursquare y no se cambia a mano.",
  "dbError.health_consent_required": "Falta el permiso para datos de salud.",
  "dbError.invalid_coordinates": "Las coordenadas no son válidas.",
  "dbError.profile_required": "Falta el perfil de la persona.",
  "dbError.publish_requires_verification": "No se puede publicar: la ubicación y el estado del negocio deben estar verificados.",
  "dbError.refresh_limit_reached": "Ya pediste muchas revisiones en la última hora. Espera un poco.",
  "dbError.report_limit_reached": "Se alcanzó el límite de reportes de hoy.",
  "dbError.restriction_tag_mismatch": "La etiqueta no corresponde al tipo de restricción.",
  "dbError.source_not_storable": "Esta fuente no permite guardar su contenido.",
  "dbError.source_identity_locked": "El código, la familia y la regla de guardado de una fuente solo cambian con una migración.",
  "dbError.suggestion_limit_reached": "Se alcanzó el límite de recomendaciones de hoy.",
  "dbError.suggestion_not_open": "Esta recomendación ya fue revisada.",
  "dbError.team_account_not_invited": "Solo las cuentas invitadas desde Supabase pueden unirse al equipo.",
  "dbError.team_only": "Tu rol no permite este cambio.",
  "dbError.evidence_already_discarded": "Esta evidencia ya fue descartada.",
  "dbError.evidence_not_discardable": "Solo se descartan observaciones (visitas, fotos, llamadas del equipo). La evidencia de plataformas y del negocio viene de los procesos automáticos.",
  "dbError.evidence_not_found": "Esta evidencia no existe.",
  "dbError.evidence_owner_only": "Solo quien registró esta observación o un admin puede descartarla.",
  "dbError.field_policy_locked": "La vigencia de cada dato solo cambia con una migración.",
  "dbError.place_not_published": "Este lugar no está publicado.",
  "dbError.visit_limit_reached": "Se alcanzó el límite de visitas de hoy.",
  "evidence.discardReason.help": "No escribas datos personales en la razón.",
  "app.titleSuffix": "Antoja · Consola",
  "common.cancel": "Cancelar",
  "nav.queueShort": "Cola",
  "places.subtitle.one": "1 lugar en el catálogo",
  "place.families": "{count} familias de fuentes",
  "place.families.one": "1 familia de fuentes",
  "place.expires": "vence el {date}",
  "place.unpublishConfirm": "¿Quitarlo de la app? Dejará de aparecer en las recomendaciones hasta que lo publiques de nuevo.",
  "place.unpublishYes": "Sí, quitar de la app",
  "nav.queue": "Cola de revisión",
  "nav.soon": "Pronto",
  "password.show": "Mostrar contraseña",
  "account.password.checks.length": "Al menos 12 caracteres",
  "account.password.checks.tooLong": "No tan larga: las tildes y la ñ cuentan doble",
  "account.password.checks.guessable": "Difícil de adivinar (sin antoja, tu nombre ni secuencias)",
  "account.password.checks.match": "Las dos contraseñas coinciden",
  "account.password.checks.state.pending": "pendiente",
  "account.password.checks.state.ok": "cumple",
  "account.password.checks.state.problem": "no cumple",
  "account.password.checks.summary": "Tu contraseña cumple {done} de {total} requisitos.",
  "dbError.dish_invalid": "Revisa los platos: cada uno necesita un nombre y, si tiene precio, un número mayor que cero.",
  "dbError.menu_already_added": "Esa carta ya está en este lugar.",
  "dbError.menu_link_only": "Las cartas de plataformas son solo un enlace: no se leen ni se copian.",
  "dbError.menu_not_found": "Esta carta no existe o no tienes acceso.",
  "dbError.menu_url_invalid": "Escribe la dirección completa, por ejemplo https://restaurante.co/carta.pdf.",
  "dbError.menu_url_is_platform": "Ese enlace es de una plataforma (Rappi, Menüpp, DiDi, Tripadvisor u otra) o es un enlace acortado. Aquí va la página, el PDF o el documento de Google del propio negocio.",
  "dbError.place_not_found": "Este lugar no existe o no tienes acceso.",
  "dbError.pilot_place_linked": "Esta entrada ya está vinculada. Quita el vínculo antes de marcarla como fuera de Foursquare.",
  "dbError.pilot_place_not_found": "Esta entrada de la lista piloto no existe.",
  "dbError.pilot_place_taken": "Ese lugar ya está vinculado a otra entrada de la lista piloto.",
  "dbError.pilot_swap_invalid": "Solo se cambia un escogido por un lugar de la reserva del mismo barrio.",
  "dbError.pilot_swap_needs_not_in_fsq": "Solo se reemplaza un escogido sin vínculo que alguien marcó como fuera de Foursquare.",
  "dbError.pilot_swap_reserve_not_in_fsq": "Esa reserva está marcada como fuera de Foursquare: escoge otra.",
  "dbError.place_closed": "Ese lugar figura como cerrado: no se puede vincular.",
  "dbError.place_in_other_zone": "Ese lugar está en otro barrio.",
  "dbError.place_without_fsq_id": "Ese lugar no tiene registro en Foursquare.",
  "dbError.reason_required": "Escribe una razón de 3 a 80 caracteres.",
  "menus.title": "Cartas",
  "menus.loading": "Cargando cartas…",
  "menus.error": "No se pudieron cargar las cartas. Revisa tu conexión e intenta de nuevo.",
  "menus.empty": "Este lugar todavía no tiene cartas.",
  "menus.noUrl": "Carta sin enlace",
  "menus.lastRead": "leída el {date}",
  "menus.url": "Enlace de la carta",
  "menus.urlHint": "La página, el PDF o el documento de Google del propio negocio (Drive, Docs y Sites quedan solo como enlace). Rappi, Menüpp, DiDi, Tripadvisor y los enlaces acortados no se aceptan.",
  "menus.add": "Agregar carta",
  "menus.adding": "Agregando…",
  "menus.added": "Carta agregada.",
  "menuFormat.web": "Página web",
  "menuFormat.pdf": "PDF",
  "menuFormat.image": "Foto",
  "menuFormat.link": "Solo enlace",
  "menuStatus.pending": "Por leer",
  "menuStatus.first_read": "Primera lectura",
  "menuStatus.double_read": "Dos lecturas",
  "menuStatus.in_review": "En revisión",
  "menuStatus.published": "Publicada",
  "menuStatus.link_only": "Solo enlace",
  "menuStatus.expired": "Vencida",
  "menu.backToPlace": "Lugar",
  "menu.loading": "Cargando la carta…",
  "menu.error": "No se pudo cargar la carta. Revisa tu conexión e intenta de nuevo.",
  "menu.title": "Carta de {place}",
  "menu.open": "Abrir la carta",
  "menu.newTab": "(se abre en otra pestaña)",
  "menu.empty": "Todavía no hay lecturas de esta carta. La primera la hace un editor o la lectura automática.",
  "menu.dishes": "Platos",
  "menu.removeHint": "Lo que difiere entre las lecturas empieza vacío: escríbelo solo si lo confirmaste. Para quitar un plato de Antoja, borra su nombre y guarda.",
  "menu.column.first": "Primera lectura",
  "menu.column.second": "Segunda lectura",
  "menu.column.compare": "Comparación",
  "menu.compare.same": "Coinciden",
  "menu.compare.price": "Precio distinto",
  "menu.compare.missing": "Falta en una lectura",
  "menu.compare.tags": "Etiquetas distintas: revisa alérgenos y dietas",
  "menu.compare.pending": "Falta la segunda lectura",
  "menu.compare.onlyAntoja": "Solo en Antoja",
  "menu.compare.added": "Plato nuevo",
  "menu.pending": "Pendiente",
  "menu.notInReading": "No aparece",
  "menu.notInAntoja": "No está en Antoja",
  "menu.noPrice": "Sin precio",
  "menu.newDish": "plato nuevo {n}",
  "menu.nameLabel": "Nombre en Antoja de {dish}",
  "menu.priceLabel": "Precio en Antoja de {dish}",
  "menu.addDish": "Agregar plato",
  "menu.save": "Guardar platos",
  "menu.saved": "Platos guardados.",
  "menu.unchanged": "No había cambios por guardar.",
  "menu.first.title": "Primera lectura",
  "menu.first.label": "Pega o escribe la carta",
  "menu.first.hint": "Un plato por línea, con el precio al final (por ejemplo: Sancocho de gallina $28.000). Para empezar una sección, termina la línea con dos puntos.",
  "menu.first.count": "Platos leídos: {count}",
  "menu.first.save": "Guardar primera lectura",
  "dbError.menu_changed": "Alguien cambió esta carta mientras la editabas. Recarga la página y vuelve a hacer tus correcciones.",
  "menu.linkOnly": "Esta carta queda solo como enlace: no se lee ni se copia.",
  "menu.column.dish": "Plato",
  "menu.column.name": "Nombre en Antoja",
  "menu.column.price": "Precio en Antoja",
  "menu.compare.reviewed": "Revisado",
  "menu.summary.dishes": "{count} platos",
  "menu.summary.dishes.one": "1 plato",
  "menu.summary.pending": "segunda lectura pendiente",
  "menu.summary.same": "las dos lecturas coinciden",
  "menu.summary.differences": "{count} con diferencias",
  "menu.summary.reviewed": "{count} revisadas",
  "menu.summary.reviewed.one": "1 revisada",
  "menu.toConfirm": "Por confirmar",
  "menu.unreadable": "No se pudo leer",
  "nav.pilot": "Lista piloto",
  "nav.pilotShort": "Piloto",
  "pilot.title": "Lista piloto",
  "pilot.subtitle": "Los lugares escogidos para la beta y su reserva, vinculados a Foursquare (FSQ OS Places).",
  "pilot.loading": "Cargando la lista piloto…",
  "pilot.error": "No se pudo cargar la lista piloto. Revisa tu conexión e intenta de nuevo.",
  "pilot.empty": "La lista piloto todavía no se ha importado. Se carga con la importación de Foursquare.",
  "pilot.filteredEmpty": "No hay lugares con estos filtros.",
  "pilot.readOnly": "Tu rol puede ver la lista, pero no cambiar los vínculos.",
  "pilot.summary": "Avance de los vínculos",
  "pilot.allZones": "Todos los barrios",
  "pilot.progress": "{linked} de {selected}",
  "pilot.goal": "meta {goal}",
  "pilot.goalReached": "meta {goal} cumplida",
  "pilot.reserveProgress": "Reserva: {linked} de {total}",
  "pilot.filterLabel": "Mostrar",
  "pilot.filter.all": "Todos",
  "pilot.filter.unlinked": "Sin vincular",
  "pilot.filter.doubtful": "Dudosos",
  "pilot.filter.linked": "Vinculados",
  "pilot.filter.reserve": "Reserva",
  "pilot.column.name": "Lugar",
  "pilot.column.zone": "Barrio",
  "pilot.column.role": "Rol",
  "pilot.column.link": "Vínculo",
  "pilot.column.fsq": "Lugar en Foursquare",
  "pilot.column.actions": "Acciones",
  "pilot.role.selected": "Escogido n.º {rank}",
  "pilot.role.reserve": "Reserva n.º {rank}",
  "pilot.state.linked": "Vinculado",
  "pilot.state.unmatched": "Sin vincular",
  "pilot.state.doubtful": "Dudoso",
  "pilot.state.not_in_fsq": "No está en Foursquare",
  "pilot.open.find": "Buscar en Foursquare",
  "pilot.open.linked": "Ver vínculo",
  "pilot.linkedTo": "Vinculado a {place}",
  "pilot.fsqId": "ID de Foursquare: {id}",
  "pilot.statusLine": "Estado: {status}, según {source} ({date})",
  "pilot.source.fsq": "Foursquare",
  "pilot.source.website": "la página del negocio",
  "pilot.source.other": "otra fuente",
  "pilot.candidates.title": "Lugares de Foursquare en {zone} que se parecen",
  "pilot.candidates.help": "Ordenados por parecido del nombre. La distancia es al centro del barrio.",
  "pilot.candidates.loading": "Buscando en Foursquare…",
  "pilot.candidates.error": "No se pudieron cargar los candidatos. Revisa tu conexión e intenta de nuevo.",
  "pilot.candidates.empty": "No hay lugares de Foursquare en {zone} que se parezcan.",
  "pilot.markedNotInFsq": "Marcado: no está en Foursquare.",
  "pilot.similarity": "Parecido {value}",
  "pilot.distance": "A {value} del centro del barrio",
  "pilot.link": "Vincular",
  "pilot.unlink": "Quitar vínculo",
  "pilot.notInFsq": "No está en Foursquare",
  "pilot.done.linked": "Se vinculó {name} a {place}.",
  "pilot.done.unlinked": "Se quitó el vínculo de {name}.",
  "pilot.done.notInFsq": "{name} se marcó como fuera de Foursquare.",
  "pilot.done.swapped": "Se reemplazó {name} por {reserve}.",
  "pilot.swap.open": "Reemplazar con la reserva",
  "pilot.swap.legend": "Reserva de {zone} vinculada a Foursquare",
  "pilot.swap.none": "No hay lugares de la reserva de {zone} vinculados a Foursquare. Vincula uno primero.",
  "pilot.swap.reason": "Razón del cambio",
  "pilot.swap.reasonHint": "De 3 a 80 caracteres; llevas {count}. Queda en el historial.",
  "pilot.swap.review": "Revisar el cambio",
  "pilot.swap.confirm": "¿Reemplazar {name} por {reserve}? {name} pasa a la reserva.",
  "pilot.swap.yes": "Sí, reemplazar",
  "pilot.linkedWord": "vinculados",
  "pilot.noSelected": "Sin lugares escogidos",
  "pilot.reserveNone": "Sin reserva en este barrio",
  "pilot.countUnit": "lugares",
  "pilot.filterOption": "{label} ({count})",
  "pilot.notInFilter": "Ya no coincide con el filtro",
  "pilot.noFsqPlace": "Sin lugar",
  "pilot.open.findLabel": "Buscar en Foursquare: {name}",
  "pilot.open.linkedLabel": "Ver vínculo: {name}",
  "pilot.linkLabel": "Vincular: {name}",
  "pilot.takenBy": "Ya vinculado a {name}",
  "pilot.lowSimilarity": "Poco parecido",
  "pilot.candidates.noneLikely": "Ningún lugar se parece mucho.",
  "pilot.candidates.others": "Ver otros lugares de {zone}",
  "pilot.doubtfulHint": "Hay varios lugares parecidos: escoge el correcto.",
  "pilot.swap.noChoice": "Escoge un lugar de la reserva.",
  "pilot.swap.badReason": "Escribe una razón de 3 a 80 caracteres.",
  "dbError.place_closed": "Ese lugar figura como cerrado: no se puede vincular.",
  "pilot.swap.noReserve": "{zone} no tiene reserva.",
  "pilot.anotherRow": "otra entrada de la lista"
}
